import React from 'react'

import { Box, Text } from '@driftt/dds'
export interface TooltipBodyProps {
  children: string
  size?: 'small' | 'medium' | 'large'
}

const SIZE_MAP = {
  small: '150px',
  medium: '200px',
  large: '250px'
}
const TooltipBody = ({ children, size = 'small' }: TooltipBodyProps) => {
  return (
    <Box
      css={{
        background: '$white',
        padding: '$1',
        borderTop: '$lime3 4px solid',
        width: SIZE_MAP[size],
        borderRadius: '$1',
        boxShadow: '$1'
      }}>
      <Text
        variant="body"
        css={{
          textAlign: 'center'
        }}>
        {children}
      </Text>
    </Box>
  )
}

export default TooltipBody
